import { envConfig } from 'utility/env_config';

export const globalEndpoints = {
  apiUrl: envConfig.apiUrl,
  logClientError: () => `${globalEndpoints.apiUrl}/ErrorLogging/LogClientError`,
};
